<ion-header class="header-light">
  <ion-toolbar class="gradient-primary-right">
    <ion-buttons slot="start">
      <ion-menu-button>
        <ion-icon class="icon-menu" color="dark" name="menu"></ion-icon>
        <app-inbox-count></app-inbox-count>
      </ion-menu-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'MENU.gift' | translate }}
    </ion-title>
  </ion-toolbar>
  <ion-toolbar class="gradient-primary-right ion-no-padding">
    <app-news-card-slide class="full-width" [newsCardSlideType]="'gift_home'" [setReady]="ready"></app-news-card-slide>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding-vertical" color="light">
  <ion-refresher class="background-light" slot="fixed" (ionRefresh)="doRefresh($event)">
    <ion-refresher-content class="background-light"
      pullingIcon="chevron-down-circle-outline"
      pullingText=""
      refreshingSpinner="circles"
      refreshingText="">
    </ion-refresher-content>
  </ion-refresher>

  <div class="content-div">
    <ion-grid class="ion-no-padding" fixed>
      <ion-row>
        <ion-col *ngIf="checkinSetting?.giftRecord && !checkinSetting?.giftDetail">
          <app-gift-statistic-item class="full-width" [reset]="reset" [all]="true" [showNumber]="true" [cardType]="'rect'" [color]="'tertiary'" [statisticType]="'received'" [name]="'GIFT.lbl.received_checkin' | translate" [setGiftType]="''" [setInvitedBy]="invitedBy" [whiteBackground]="true">
          </app-gift-statistic-item>
        </ion-col>
        <ion-col>
          <app-gift-statistic-item class="full-width" [reset]="reset" [all]="true" [showNumber]="true" [cardType]="'rect'" [color]="'tertiary'" [statisticType]="'recorded'" [name]="'GIFT.lbl.recorded_gift' | translate" [setGiftType]="''" [setInvitedBy]="invitedBy" [whiteBackground]="true">
          </app-gift-statistic-item>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="ion-padding" *ngIf="invitedByList?.length > 1">
      <ion-segment [(ngModel)]="invitedBy" scrollable>
        <ion-segment-button [value]="''">
          <ion-text>
            <div>{{'LBL.all' | translate }}</div>
          </ion-text>
        </ion-segment-button>
        <ng-container *ngIf="invitedByList?.length > 1">
          <ion-segment-button [value]="invitedBy" *ngFor="let invitedBy of invitedByList">
            <ion-text>
              <ng-container *ngIf="invitedBy.custom">{{ invitedBy.value }}</ng-container>
              <ng-container *ngIf="!invitedBy.custom">
                <div>{{ 'LIST.invited_by.' + invitedBy.value | translate }}</div>
              </ng-container>
            </ion-text>
          </ion-segment-button>
        </ng-container>
      </ion-segment>
    </div>
  
    <ion-grid class="ion-no-padding" fixed>
      <ion-row>
        <ion-col>
          <app-gift-statistic-item class="full-width" [reset]="reset" [all]="true" [showNumber]="true" [cardType]="'rect'" [color]="'tertiary'" [name]="'LIST.gift.other' | translate" [setGiftType]="'other'" [setInvitedBy]="invitedBy" [whiteBackground]="true">
          </app-gift-statistic-item>
        </ion-col>
        <ion-col>
          <app-gift-statistic-item class="full-width" [reset]="reset" [all]="true" [showNumber]="true" [cardType]="'rect'" [color]="'tertiary'" [name]="'LIST.gift.cash' | translate" [setGiftType]="'cash'" [setInvitedBy]="invitedBy" [whiteBackground]="true">
          </app-gift-statistic-item>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ng-container *ngFor="let currency of currencyList">
      <app-gift-statistic-item class="full-width" [reset]="reset" [all]="true" [showNumber]="true" [cardType]="'block'" [name]="'LIST.gift.cash' | translate" [setGiftType]="'cash'" [currency]="currency" [setInvitedBy]="invitedBy" [whiteBackground]="true">
      </app-gift-statistic-item>
    </ng-container>
  </div>
  
</ion-content>
